import { login, forget, register, refresh, getInfo, logout } from '../api/auth.service'
import { updateUserInfo } from '../api/users.service.js'

export default {
  state:{
    currentUser: {}
  },
  getters: {
    getCurrentUser(state){
      return state.currentUser
    }
  },
  mutations: {
    setCurrentUser(state, user){
      state.currentUser = user
    }
  },
  actions: {
    setCurrentUser(context, user){
      context.commit('setCurrentUser', user)
    },
    
    async forget (context, email){
      console.log("mail user store ", email)
      let usr = await forget(email)
      // context.commit('setCurrentUser', usr)
      // return usr
    },
    async login (context, user){
      let usr = await login(user)
      context.commit('setCurrentUser', usr)
      return usr
    },
    async register(context, user) {
      let usr = await register(user)
      context.commit('setCurrentUser', usr)
      return usr
    },

    async logout(context) {
      let usr = await logout()
      console.log('test logout ', usr)
      context.commit('setCurrentUser', usr)
    },
    
    async refresh(context) {
      let token = await refresh();
      let user = await getInfo(token);
      context.commit("setCurrentUser", user);
      return user;
    },

    async updateUser(context, user) {
      let userUp = await updateUserInfo(user)
      context.commit('setCurrentUser', userUp)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/auth.store.js